<ng-container *ngIf="hasFavourite">
  <div edsFlexbox justifyContent="center">
    <button class="transparent" (click)="toggle()">
      <eds-icon
        class="fav-icon"
        [type]="active ? 'bookmark-active' : 'bookmark-inactive'"
        edsTooltip
        tooltipType="medium"
        [tooltipPositionDefault]="'bottom'"
        tooltipBehavior="absolute"
        [tooltipContent]="tooltipContent"
        (tooltipClickedEmit)="onTooltipClicked($event)"
        (onTooltipCloseEmit)="onTooltipClicked($event)"
      >
      </eds-icon>
    </button>
  </div>
</ng-container>
